import type { OrganizationRepository } from '@/core/organization'
import type { UseCase } from '@/core/shared'

export const editBillingInfo: UseCase<OrganizationRepository, 'editBillingInfo'> = repository => {
  return async (groupUid, billingInfo) => {
    await repository.editBillingInfo(groupUid, billingInfo)
  }
}
